import { z } from "zod";

export const registedUser = z.object({
  username: z.string().min(1, {
    message: "Username can't be empty.",
  }),
  password: z.string().min(1, {
    message: "Password can't be empty.",
  }),
});

export const magicLinkUser = z.object({
  email: z.string().email({
    message: "Invalid Email",
  }),
});

export const credientialUserSignUp = z
  .object({
    username: z.string().min(4, {
      message: "无效用户名",
    }),
    email: z.string().email({
      message: "无效邮箱",
    }),
    code: z.string().length(6, {
      message: "无效验证码",
    }),
    password: z.string().min(8, {
      message: "无效密码",
    }),
    passwordConfirm: z.string().min(8, {
      message: "无效密码",
    }),
  })
  .refine(({ passwordConfirm, password }) => password === passwordConfirm, {
    message: "密码不一致",
    path: ["passwordConfirm"],
  });

export const credientialResetPwd = z
  .object({
    email: z.string().email({
      message: "无效邮箱",
    }),
    code: z.string().length(6, {
      message: "无效验证码",
    }),
    password: z.string().min(8, {
      message: "无效密码",
    }),
    passwordConfirm: z.string().min(8, {
      message: "无效密码",
    }),
  })
  .refine(({ passwordConfirm, password }) => password === passwordConfirm, {
    message: "密码不一致",
    path: ["passwordConfirm"],
  });

export const credientialUserLogin = z.object({
  email: z.string().min(4, {
    message: "无效邮箱/用户名",
  }),
  password: z.string().min(8, {
    message: "无效密码",
  }),
});

export const smsUserLogin = z.object({
  phoneNumber: z.string().min(11, {
    message: "手机号格式错误",
  }),
  smsCode: z.string().length(6, {
    message: "验证码格式错误",
  }),
  shareCode: z.string().nullish(),
});

export const pwdUserLogin = z.object({
  phoneNumber: z.string().min(11, {
    message: "手机号格式错误",
  }),
  password: z.string().min(8, {
    message: "密码格式错误",
  }),
});
export const smsUserResetPwdLogin = z
  .object({
    phoneNumber: z.string().min(11, {
      message: "手机号格式错误",
    }),
    smsCode: z.string().length(6, {
      message: "验证码格式错误",
    }),
    password: z.string().min(8, {
      message: "密码格式错误",
    }),
    passwordConfirm: z.string().min(8, {
      message: "密码格式错误",
    }),
  })
  .refine(({ passwordConfirm, password }) => password === passwordConfirm, {
    message: "密码不一致",
    path: ["passwordConfirm"],
  });
const pswReg = /^[a-zA-Z0-9_!@#$%^&*()_+\-=\[\]{};:'",.<>?]{8,18}$/;
export const resetPwdSchema = z
  .object({
    password: z.string().regex(pswReg, {
      message: "8-18个数字、字符和特殊字符",
    }),
    passwordConfirm: z.string().regex(pswReg, {
      message: "8-18个数字、字符和特殊字符",
    }),
  })
  .refine(({ passwordConfirm, password }) => password === passwordConfirm, {
    message: "密码不一致",
    path: ["passwordConfirm"],
  });
